import React, { useEffect, useRef, useState } from "react";
import io from "socket.io-client";
import { useDeviceStatus } from "../../DeviceStatusContext";
import { getSocketConfig } from "./config";

const ConnectionManager = () => {
  const { deviceStatus, setDeviceStatus } = useDeviceStatus();
  const socketRef = useRef(null);
  const [socketReady, setSocketReady] = useState(false);
  const lastEmitTimeRef = useRef(0);

  console.log('socketReady: ', socketReady);
  useEffect(() => {
    const interval = setInterval(() => {
      const raw = sessionStorage.getItem("soketVariable");
      console.log("[interval] raw:", raw); // 👈 add this
      const config = getSocketConfig();
      console.log("[interval] config:", config); // 👈 and this
      if (config?.address && config?.SoPath && config?.di) {
        setSocketReady(true);
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!socketReady) return;
    const { address, SoPath, di } = getSocketConfig();
    const socket = io.connect(address, {
      path: SoPath,
      transports: ["websocket"],
      reconnection: true,
    });
    console.log('socket: ', socket);

    socketRef.current = socket;

    socket.on("connect", () => {
      console.log("[TV] Socket connected");
      socket.emit("joinRoom", di);
    });

    socket.on("disconnect", () =>
      console.log("[TV] Socket disconnected")
    );

    socket.on("connect_error", (error) =>
      console.error("[TV] Connection Error:", error)
    );

    socket.on("connectToRoom", (data) =>
      console.log("[TV] Connected to room:", data)
    );

    socket.on("ReceiveSignal", (data) => {
      try {
        if (data?.tvar) {
          console.log("[TV] ReceiveSignal:", data);
          comboRebind(data.tvar, data.tparam);
        }
      } catch (err) {
        console.error("[TV] ReceiveSignal error:", err);
      }
    });

    return () => socket.disconnect();
  }, [socketReady]);

  useEffect(() => {
    if (!deviceStatus?.type) return;
    if (!socketRef.current?.connected) return;
    if (deviceStatus.type === "REFRESH_SLIDER") return;

    const now = Date.now();
    if (now - lastEmitTimeRef.current < 500) return; // debounce

    lastEmitTimeRef.current = now;
    handleBtnClick(deviceStatus.type);
  }, [deviceStatus]);


  const handleBtnClick = (signal) => {
    console.log("[TV] Emit signal:", signal);
    const socket = socketRef.current;
    if (!socket?.connected) {
      console.error("[TV] Socket not connected");
      return;
    }
    const config = getSocketConfig();
    socket.emit("SendSignal", {
      roomno: config.di,
      tmode: "SendSignal",
      tvar: signal,
      deviceId: deviceStatus?.uniqueId,
    });
  };

  const comboRebind = (_tvar, _tparam) => {
    const signal = _tvar?.toLowerCase()?.trim();
    console.log("[TV] comboRebind:", signal, _tparam);
    switch (signal) {
      case "contentchanged":
        console.log('contentchanged call 1');
        setDeviceStatus({
          type: "REFRESH_SLIDER",
          timestamp: Date.now(),
        });
        break;

      case "reacttest":
        alert("This is testing for socket");
        break;

      case "devicedisabled":
        console.log("devicedisabled call");
        break;

      case "deviceenabled":
        console.log("deviceenabled call");
        break;

      case "forcelogout":
        console.log("forcelogout call");
        break;

      case "accountdeleted":
        console.log("accountdeleted call");
        break;

      case "customerbindchanged":
        console.log("customerbindchanged call");
        break;

      case "metal":
        alert("Metal change happened");
        break;

      default:
        console.warn("[TV] Unknown signal:", signal);
        break;
    }
  };

  return null;
};

export default ConnectionManager;
